export const EXPAND_COMPONENT_LAYER = 'expandComponentLayer'
export const UNEXPAND_COMPONENT_LAYER = 'unexpandComponentLayer'
export const TOGGLE_EXPAND_COMPONENT_LAYER = 'toggleExpandComponentLayer'
